import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { CardModule } from "primeng/card";
import { PanelModule } from "primeng/panel";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { RatingModule } from "primeng/rating";

import { MzTabResult } from "../../../../modules/lipidcompass-backend-client";
import { LoggingService, LogLevel } from "../../_services/logging.service";
import { CvparameterClassificationComponent } from "../../layouts/cvparameter-classification/cvparameter-classification.component";
import { OlslinkComponent } from "../../olslink/olslink.component";
import { DatasetDetailPlotsComponent } from "../dataset-detail-plots/dataset-detail-plots.component";

export class CurationLevel {
  value: number = 1;
  label: MzTabResult.CurationLevelEnum =
    MzTabResult.CurationLevelEnum.UNCHECKED;
  ncases: number = Object.keys(MzTabResult.CurationLevelEnum).length - 1;
}

@Component({
  selector: "app-dataset-card",
  templateUrl: "./dataset-card.component.html",
  styleUrls: ["./dataset-card.component.css"],
  standalone: true,
  imports: [
    CardModule,
    CommonModule,
    CvparameterClassificationComponent,
    DatasetDetailPlotsComponent,
    FormsModule,
    OlslinkComponent,
    PanelModule,
    ProgressSpinnerModule,
    RatingModule,
    RouterModule,
    TranslateModule
  ]
})
export class DatasetCardComponent implements OnChanges {
  private loggingService = inject(LoggingService);

  @Input() mzTabResult: MzTabResult;

  @Input() detailView: boolean = false;

  @Input() showClassifications: boolean = true;

  @Input() showDatasetLink: boolean = true;

  @Input() showPlots: boolean = true;

  @Input() toggleable: boolean = true;

  public curationLevel: CurationLevel = new CurationLevel();

  ngOnChanges(changes: SimpleChanges): void {
    this.loggingService.log(
      "DatasetCardComponent",
      "mzTabResult: " + JSON.stringify(this.mzTabResult),
      LogLevel.DEBUG
    );
    if (changes?.mzTabResult?.currentValue) {
      if (this.mzTabResult?.curationLevel) {
        this.curationLevel.label = this.mzTabResult
          ?.curationLevel as MzTabResult.CurationLevelEnum;
      }
      switch (this.mzTabResult?.curationLevel) {
        case MzTabResult.CurationLevelEnum.UNCHECKED:
          this.curationLevel.value = 1;
          break;
        case MzTabResult.CurationLevelEnum.AUTOMATICALLY_CHECKED:
          this.curationLevel.value = 2;
          break;
        case MzTabResult.CurationLevelEnum.MANUALLY_CURATED:
          this.curationLevel.value = 3;
          break;
        case MzTabResult.CurationLevelEnum.REFERENCE:
          this.curationLevel.value = 4;
          break;
        default:
          this.curationLevel.value = 0;
          this.loggingService.log(
            "DatasetCardComponent",
            "Unknown curationLevel: " + this.mzTabResult?.curationLevel,
            LogLevel.ERROR
          );
          break;
      }
      if (!this.detailView || !this.showPlots) {
        this.loggingService.log(
          "DatasetCardComponent",
          "Not loading plot data. Set 'detailView=true and showPlots=true' to enable plot data loading!",
          LogLevel.DEBUG
        );
      }
    }
  }
}
